<script setup>
import BaseSettingsListItem from '../../components/BaseSettingsListItem.vue';
import SLAResponseTime from './SLAResponseTime.vue';
import SLABusinessHoursLabel from './SLABusinessHoursLabel.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  slaName: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  firstResponse: {
    type: String,
    required: true,
  },
  nextResponse: {
    type: String,
    required: true,
  },
  resolutionTime: {
    type: String,
    required: true,
  },
  hasBusinessHours: {
    type: Boolean,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isDeleted: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['delete', 'edit', 'reactivate', 'hardDelete']);
</script>

<template>
  <BaseSettingsListItem
    class="sm:divide-x sm:divide-n-weak"
    :title="slaName"
    :description="description"
  >
    <template #label>
      <SLABusinessHoursLabel :has-business-hours="hasBusinessHours" />
    </template>
    <template #rightSection>
      <div
        class="flex items-center divide-x rtl:divide-x-reverse sm:rtl:!border-l-0 sm:rtl:!border-r sm:rtl:border-solid sm:rtl:border-n-weak gap-1.5 w-fit sm:w-full sm:gap-0 sm:justify-between divide-n-weak"
      >
        <SLAResponseTime response-type="FRT" :response-time="firstResponse" />
        <SLAResponseTime response-type="NRT" :response-time="nextResponse" />
        <SLAResponseTime response-type="RT" :response-time="resolutionTime" />
      </div>
    </template>
    <template #actions>
      <div class="flex flex-col items-center gap-2">
        <Button
          v-tooltip.top="$t('SLA.FORM.EDIT')"
          faded
          slate
          sm
          icon="i-lucide-edit"
          :is-loading="isLoading"
          @click="emit('edit')"
        />
        <Button
          v-if="!isDeleted"
          v-tooltip.top="$t('SLA.FORM.DEACTIVATE')"
          faded
          ruby
          sm
          icon="i-lucide-clock-fading"
          :is-loading="isLoading"
          @click="emit('delete')"
        />
        <Button
          v-if="isDeleted"
          v-tooltip.top="$t('SLA.FORM.REACTIVATE')"
          faded
          green
          sm
          icon="i-lucide-rotate-ccw"
          :is-loading="isLoading"
          @click="emit('reactivate')"
        />
        <Button
          v-if="isDeleted"
          v-tooltip.top="$t('SLA.FORM.HARD_DELETE')"
          faded
          ruby
          sm
          icon="i-lucide-trash-2"
          :is-loading="isLoading"
          @click="emit('hardDelete')"
        />
      </div>
    </template>
  </BaseSettingsListItem>
</template>
